function moveReviewsContainer() {
  const reviewsContainer = document.querySelector('.reviews-page-container');
  const mediaWrapper = document.querySelector('.product__media-wrapper');
  const infoWrapper = document.querySelector('.product__info-wrapper');
  
  if (!reviewsContainer || !mediaWrapper || !infoWrapper) {
    console.warn('One or more required elements not found');
    return;
  }
  
  const isResponsive = window.innerWidth <= 767;
  
  if (isResponsive) {
    // Move to info wrapper if not already there
    if (!infoWrapper.contains(reviewsContainer)) {
      infoWrapper.appendChild(reviewsContainer);
    }
  } else {
    // Move back to media wrapper if not already there
    if (!mediaWrapper.contains(reviewsContainer)) {
      mediaWrapper.appendChild(reviewsContainer);
    }
  }
}

// Run on page load
document.addEventListener('DOMContentLoaded', moveReviewsContainer);

// Run on window resize with debouncing to prevent excessive calls
let resizeTimeout;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(moveReviewsContainer, 150);
});
    